<template>
  <div class="application-wrapper">
    <div class="side-swap-arrow-wrapper last">
      <div class="arrow-body"></div>
    </div>
    <div class="bottom-swap-arrow-wrapper">
      <div class="arrow-body"></div>
      <div class="arrow-down-tip"></div>
    </div>
    <div class="applicant-card">
      <div class="applicant-spinner">
        <BaseLoadingSpinner />
        <p>Lägger till...</p>
      </div>
      <div class="applicant-card-head is-blurry">
        <svg
          class="icon"
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.3284 17.504L21.3284 1.50399C20.9626 1.17856 20.49 0.998779 20.0004 0.998779C19.5108 0.998779 19.0382 1.17856 18.6724 1.50399L0.672403 17.504C0.275639 17.8562 0.0350397 18.3516 0.00353359 18.8812C-0.0279725 19.4108 0.152196 19.9312 0.504403 20.328C0.856611 20.7248 1.35201 20.9654 1.88161 20.9969C2.41121 21.0284 2.93164 20.8482 3.3284 20.496L4.0004 19.898V39C4.0004 39.5304 4.21112 40.0391 4.58619 40.4142C4.96126 40.7893 5.46997 41 6.0004 41H34.0004C34.5308 41 35.0395 40.7893 35.4146 40.4142C35.7897 40.0391 36.0004 39.5304 36.0004 39V19.898L36.6724 20.496C37.0692 20.8482 37.5896 21.0284 38.1192 20.9969C38.3814 20.9813 38.638 20.9142 38.8743 20.7994C39.1106 20.6846 39.322 20.5244 39.4964 20.328C39.6708 20.1315 39.8048 19.9026 39.8907 19.6544C39.9767 19.4062 40.0129 19.1434 39.9973 18.8812C39.9817 18.619 39.9146 18.3624 39.7998 18.1261C39.685 17.8898 39.5249 17.6784 39.3284 17.504ZM14.3684 37C14.7757 35.8309 15.5367 34.8175 16.5459 34.1004C17.5551 33.3834 18.7624 32.9981 20.0004 32.9981C21.2384 32.9981 22.4457 33.3834 23.4549 34.1004C24.4641 34.8175 25.2251 35.8309 25.6324 37H14.3684ZM17.0004 26C17.0004 25.4066 17.1763 24.8266 17.506 24.3333C17.8356 23.8399 18.3042 23.4554 18.8524 23.2284C19.4005 23.0013 20.0037 22.9419 20.5857 23.0576C21.1676 23.1734 21.7022 23.4591 22.1217 23.8787C22.5413 24.2982 22.827 24.8328 22.9428 25.4147C23.0585 25.9967 22.9991 26.5999 22.772 27.148C22.545 27.6962 22.1605 28.1648 21.6671 28.4944C21.1738 28.824 20.5937 29 20.0004 29C19.2051 28.9989 18.4426 28.6825 17.8803 28.1201C17.3179 27.5578 17.0015 26.7953 17.0004 26ZM32.0004 37H29.7984C29.5218 35.674 28.9787 34.418 28.2021 33.3082C27.4255 32.1984 26.4315 31.258 25.2804 30.544C26.3828 29.2862 26.9937 27.6725 27.0004 26C27.0004 24.1435 26.2629 22.363 24.9501 21.0502C23.6374 19.7375 21.8569 19 20.0004 19C18.1439 19 16.3634 19.7375 15.0507 21.0502C13.7379 22.363 13.0004 24.1435 13.0004 26C13.0071 27.6725 13.618 29.2862 14.7204 30.544C13.569 31.2578 12.5746 32.1981 11.7976 33.3079C11.0206 34.4177 10.4772 35.6738 10.2004 37H8.0004V16.342L20.0004 5.67599L32.0004 16.342V37Z"
            fill="#878b9d"
          />
        </svg>
        <div class="applicant-card-details">
          <div class="applicant-card-title-wrapper">
            <h4 class="title-strong">Lägenhet {{ apartmentLetter }}</h4>
          </div>

          <span class="description-text"></span>
        </div>
      </div>
      <div class="applicant-card-body is-blurry">
        <div class="input-group">
          <div class="input-description-wrapper">
            <div class="label-wrapper">
              <strong>För- och efternamn</strong>
              <span v-if="!isLb" class="description-text">
                / Skriv in för- och efternamn på personen som bor i Lägenhet
                {{ apartmentLetter }}
                i nuläget.
              </span>
            </div>
          </div>
          <SwapInput :disabled="true" label="" description="" />
        </div>
        <div class="input-group">
          <div class="input-description-wrapper">
            <div class="label-wrapper">
              <strong>E-post</strong>
              <span class="description-text">
                / Ange e-post om du vill bjuda in personen att hantera sina egna
                uppgifter
              </span>
            </div>
          </div>
          <div class="input-email">
            <SwapInput :disabled="true" label="" description="" />
            <InviteButton :is-disabled="true" applicant-id="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwapInput from '@/components/SwapInput.vue';
import InviteButton from '@/components/InviteButton.vue';
import BaseLoadingSpinner from '@/components/BaseLoadingSpinner.vue';

export default {
  name: 'FakeApplicationCard',
  components: {
    SwapInput,
    InviteButton,
    BaseLoadingSpinner
  },
  props: {
    apartmentLetter: {
      type: String,
      default: 'A'
    },
    isLb: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style></style>
